import React from "react";
import "./Service.css";

function Service() {
  return (
    <div className="service component__space" id="Services">

      <div className="heading">
        <h1 className="heading">SKILLS & CERTIFICATES</h1>
        <p className="heading p__color">
•	Knowledge of multiple front-end languages and libraries (HTML/ CSS, JavaScript, XML, jQuery)
•	Knowledge of multiple back-end languages (Java, Python) and JavaScript frameworks (Angular, React, Node.js)
•	Familiarity with databases (MySQL,Postgres), web servers (Apache) 
•	Java SE 8 and Java EE
•	Spring Boot
•	Postgres
•	Maven
•	Model View Controller
•	ReSTful Webservices 
•	Spring Framework
•	XML 
•	JSON
•	Docker 

        </p>
        <p className="heading p__color">

          •	Liferay DXP 7.2 Front-end Developer – Liferay University : 2022
          •	Information Technology in Systems Development NQF Level 5- MICTSeta : 2021
          •	BSc Computer Science (incomplete) – Walter Sisulu University : 2010
          •	HTML, Java Certificate, SQL Certificate – Udemy, JavaScript : 2021
          

        </p>
      </div>

      
    </div>
  );
}

export default Service;
